module.exports = __webpack_public_path__ + "static/media/17_shape_r.2fc28bec.webp";